export default {"src":"/_next/static/media/0xac3e018457b222d93114458476f3e3416abbe38f.5a21f87a.svg","height":284,"width":284,"blurWidth":0,"blurHeight":0};